export const initialTableData = {
  page: 1,
  totalPages: 1,
  data: Array<any>(),
  actions: Array<any>(),
};